"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopGame = DesktopGame;
const React = __importStar(require("react"));
const react_jss_1 = require("react-jss");
const Footer_1 = require("../../../ui/Footer");
const TabMenu_1 = require("../../../ui/TabMenu");
const AnnouncementsBanner_1 = require("../../AnnouncementsBanner");
const TopBar_1 = require("../../TopBar");
const board_1 = require("../../board");
const SellPieceButton_1 = require("../../board/overlays/controls/SellPieceButton");
const cardShop_1 = require("../../cardShop/cardShop");
const help_1 = require("../../help");
const playerList_1 = require("../../playerList/playerList");
const profile_1 = require("../../profile");
const settings_1 = require("../../settings");
const useStyles = (0, react_jss_1.createUseStyles)({
    helpContainer: {
        padding: "0.5em",
        background: "#566c86",
    },
    game: {
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "row",
        gap: "16px",
    },
    board: {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        flex: 3,
    },
    leftColumn: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        gap: "16px",
    },
    rightColumn: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        gap: "16px",
    },
    controls: {
        height: "128px",
    },
    tabMenu: {
        flex: 1,
    },
    fixed: {
        height: "256px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
});
function DesktopGame() {
    const styles = useStyles();
    const leftTabs = React.useMemo(() => [
        {
            label: "Players",
            content: React.createElement(playerList_1.PlayerList, null),
        },
        {
            label: "Stats",
            content: React.createElement("span", null, "coming back soon"),
        },
        {
            label: "Help",
            content: (React.createElement("div", { className: styles.helpContainer },
                React.createElement(help_1.Help, { hideFooter: true }))),
        },
        {
            label: "Settings",
            content: (React.createElement("div", { className: styles.helpContainer },
                React.createElement(settings_1.Settings, null),
                React.createElement(Footer_1.Footer, null))),
        },
    ], [styles.helpContainer]);
    return (React.createElement("div", { className: styles.game },
        React.createElement("div", { className: styles.leftColumn },
            React.createElement(TabMenu_1.TabMenu, { tabs: leftTabs, className: styles.tabMenu }),
            React.createElement("div", { className: styles.fixed },
                React.createElement(profile_1.PlayerGameProfile, null))),
        React.createElement("div", { className: styles.board },
            React.createElement(TopBar_1.TopBar, null),
            React.createElement(AnnouncementsBanner_1.AnnouncementsBanner, null),
            React.createElement(board_1.BoardContainer, null)),
        React.createElement("div", { className: styles.rightColumn },
            React.createElement(cardShop_1.CardShop, null),
            React.createElement("div", { className: styles.controls },
                React.createElement(SellPieceButton_1.SellPieceButton, null)))));
}
